import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import DocumentSeparationCriteriaContMain from "presentation/view/container/Criteria/DocumentSeparationCriteriaContMain";

CommonEntrypoint(<DocumentSeparationCriteriaContMain/>)